// extracted by mini-css-extract-plugin
export var grayCircle = "_d2-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_d2-1";
export var selectedCircle = "_d2-2";
export var shippingOptionImage = "_d2-3";
export var shippingOptionWidgetPreview = "_d2-4";